module.exports = __webpack_public_path__ + "img/1.9dad7951.svg";